import React from "react";
import Button from "../Button/Button";
import Text from "../Text/Text";
import IconResource from "../../../Wrapper/IconResource/IconResource";

const NavBar = ({
  heading,
  onClick,
  button,
  buttonIcon,
  buttonIconsuff,
  setModalShow,
  Icon,
  rightButtonOnclick,
  button2,
  buttonIcon2,
  buttonIconsuff2,
  setModalShow2,
  rightButtonOnclick2

}) => {
  const rightButtonHandler2 = () => {
    setModalShow2(true)
  }
  const rightButtonHandler = () => {
    setModalShow(true);
  };

  return (
    <>
      <div className="nav_bar">
        <div className="start">
          <Button
            buttonType="icon"
            icon={<IconResource type={Icon} size={20} />}
            color="black"
            onClick={onClick}
          />
          <Text type="h2" text={heading} />
        </div>
        <div className="d-flex gap-2">
          {button ? (
            <Button
              buttonType="primary"
              prefixIcon={
                buttonIcon ? <IconResource type={buttonIcon} size={18} /> : ""
              }
              suffixIcon={
                buttonIconsuff ? (
                  <IconResource type={buttonIconsuff} size={18} />
                ) : (
                  ""
                )
              }
              text={button}
              onClick={setModalShow ? rightButtonHandler : rightButtonOnclick}
            />
          ) : null}
          {button2 ? (
            <Button
              buttonType="primary"
              prefixIcon={
                buttonIcon ? <IconResource type={buttonIcon2} size={18} /> : ""
              }
              suffixIcon={
                buttonIconsuff ? (
                  <IconResource type={buttonIconsuff2} size={18} />
                ) : (
                  ""
                )
              }
              text={button2}
              onClick={setModalShow2 ? rightButtonHandler2 : rightButtonOnclick2}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default NavBar;
